import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

// Returns the changed form values -- has similar shape as control.value, but has undefined when control is pristine
// NOTE: All values in a form array will be returned regardless of children's states
export function getChangedValues(control: AbstractControl): any {
  if (control.pristine || control.disabled) {
    return;
  }
  if (typeof control.value === 'object' && (control as UntypedFormGroup).controls) {
    if (Array.isArray((control as UntypedFormArray).controls)) {
      // Return all values of the array regardless of changedness
      return control.value.filter((v: any) => !!v);
    }
    const values = {};
    Object.keys((control as UntypedFormGroup).controls).forEach((controlKey) => {
      const c = (control as UntypedFormGroup).controls[controlKey];
      values[controlKey] = getChangedValues(c);
    });
    return values;
  } else {
    return control.value;
  }
}
